import {Sandwich} from './sandwich';
import 'latest-createjs';


const menu = {};
const buttonRoot = document.getElementById('sandwich');
const menuItems = [...document.querySelectorAll('#menu [data-section]')];
// const enquire = require('enquire.js');
// const mediator = require('./mediator');
let sandwich;

if (buttonRoot) {
    sandwich = new Sandwich(buttonRoot);
    sandwich.opened = document.body.dataset.menu === 'opened' ? true : false;

    sandwich.on('toggle', status => {
        document.body.dataset.menu = status;
    });
}

menu.close = () => {
    if (!sandwich) return;
    sandwich.opened = false;
}

menu.setCurrent = section => {
    menuItems.forEach(function (el) {
        el.classList.remove('active');
    })

    const el = document.querySelector(`#menu [data-section='${section}']`);
    if (el) el.classList.add('active');
}

if (menuItems) {
    menuItems.forEach(function (el) {
        el.addEventListener('click', () => {
            const evt = new window.createjs.Event('request');
            evt.section = el.dataset.section;
            menu.dispatchEvent(evt);
        });
    });
}

window.createjs.EventDispatcher.initialize(menu);
module.exports = menu;


// WEBPACK FOOTER //
// ./js/menu.js